import React from 'react';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import classNames from 'classnames';
import * as styles from './styles/styles.module.scss';

type Props = {
  url: string;
  title: string;
  defaultSrc: string;
  srcWithoutExt: string;
};

const ActivitySuitabilityImage = ({ url, title, defaultSrc, srcWithoutExt }: Props): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <a href={url}>
      <div className={styles.container}>
        <div className={styles.opacCover} />
        <div className={classNames(styles.title, languageRegionCode === LanguageRegionCode.German && styles.germanSizedText)}>{title}</div>
        <picture>
          <source srcSet={`${srcWithoutExt}@2x.avif`} type="image/avif" />
          <source srcSet={`${srcWithoutExt}@2x.webp`} type="image/webp" />
          <img className={styles.img} src={defaultSrc} alt="" loading="lazy" />
        </picture>
      </div>
    </a>
  );
};

export default ActivitySuitabilityImage;
